import * as actionTypes from "./actionTypes";

export const getWebsiteDataAction = () => ({
  type: actionTypes.GET_WEBSITE_DATA,
});

export const getWebsiteDataByDomainAction = (setDomainDataSession, domainDataSession) =>{
 return {type: actionTypes.GET_WEBSITE_DATA_BY_DOMAIN, setDomainDataSession, domainDataSession };
} 
export const getGoogleVerificationCodeByDomainAction = () => ({
  type: actionTypes.GET_GOOGLE_VERIFICATION_CODE_DATA,
});
export const getAdBannerByDomainAction = () =>{
 return {type: actionTypes.GET_AD_BANNER_BY_DOMAIN};
} 

export const getFeatureCardsAction = (payload) => ({
  type: actionTypes.GET_FEATURE_CARDS,
  payload,
});


export const getWebsiteRedirectionLinkDetailsAction = (id,params) => ({
  type: actionTypes.GET_WEB_REDIRECT_LINK_DETAILS,
  id,
  params
});




